enum WC_TYPES {
  FREEDOM_OF_SPEECH = 'freedom-of-speech',
  SET_1 = 'set-1',
  SET_2 = 'set-2',
  SET_3 = 'set-3'
}

export default WC_TYPES;
